"use strict";
import {
  firstFocusableIn,
  firstFocusableSlottedIn
} from "@spectrum-web-components/shared/src/first-focusable-in.js";
import { VirtualTrigger } from "./VirtualTrigger.dev.js";
import {
  BeforetoggleClosedEvent,
  BeforetoggleOpenEvent,
  forcePaint,
  guaranteedAllTransitionend,
  overlayTimer
} from "./AbstractOverlay.dev.js";
import { userFocusableSelector } from "@spectrum-web-components/shared";
export function OverlayNoPopover(constructor) {
  class OverlayWithNoPopover extends constructor {
    async managePopoverOpen() {
      await this.managePosition();
    }
    async manageDelay(targetOpenState) {
      if (targetOpenState === false || targetOpenState !== this.open) {
        overlayTimer.close(this);
        return;
      }
      if (this.delayed) {
        const cancelled = await overlayTimer.openTimer(this);
        if (cancelled) {
          this.open = !targetOpenState;
        }
      }
    }
    async ensureOnDOM(_targetOpenState) {
      forcePaint();
    }
    async makeTransition(targetOpenState) {
      if (this.open !== targetOpenState) {
        return null;
      }
      let focusEl = null;
      const start = (el, index) => () => {
        if (targetOpenState !== this.open) {
          return;
        }
        if (typeof el.open !== "undefined") {
          el.open = targetOpenState;
        }
        if (index === 0) {
          const event = targetOpenState ? BeforetoggleOpenEvent : BeforetoggleClosedEvent;
          this.dispatchEvent(new event());
        }
        if (targetOpenState !== true) {
          return;
        }
        if (el.matches(userFocusableSelector)) {
          focusEl = el;
        }
        focusEl = focusEl || firstFocusableIn(el);
        if (focusEl) {
          return;
        }
        const childSlots = el.querySelectorAll("slot");
        childSlots.forEach((slot) => {
          if (!focusEl) {
            focusEl = firstFocusableSlottedIn(slot);
          }
        });
      };
      const finish = (el, index) => () => {
        if (this.open !== targetOpenState) {
          return;
        }
        const eventName = targetOpenState ? "sp-opened" : "sp-closed";
        el.dispatchEvent(
          new CustomEvent(eventName, {
            bubbles: false,
            composed: false,
            detail: { interaction: this.type }
          })
        );
        if (index > 0) {
          return;
        }
        const hasVirtualTrigger = this.triggerElement instanceof VirtualTrigger;
        this.dispatchEvent(
          new Event(eventName, {
            bubbles: hasVirtualTrigger,
            composed: hasVirtualTrigger
          })
        );
        if (this.triggerElement && !hasVirtualTrigger) {
          this.triggerElement.dispatchEvent(
            new CustomEvent(eventName, {
              bubbles: true,
              composed: true,
              detail: { interaction: this.type }
            })
          );
        }
        this.state = targetOpenState ? "opened" : "closed";
      };
      this.elements.forEach((el, index) => {
        guaranteedAllTransitionend(
          el,
          start(el, index),
          finish(el, index)
        );
      });
      return focusEl;
    }
  }
  return OverlayWithNoPopover;
}
//# sourceMappingURL=OverlayNoPopover.dev.js.map
